// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.camera-app-live-mode-width {
    width: 1307px;
}

.camera-app-width {
    width: 1090px;
}

.camera-app-width-fullscreen {
    width: 1510px;
}

.camera-app-width-quadrant {
    width: 965px;
}

.vertical-radio-buttons {
    display: block;
    height: 30px;
    line-height: 30px;
}

.top-most-radio-button {
    border-radius: 4px 4px 0 0 !important;
}

.bottom-most-radio-button {
    border-radius: 0 0 4px 4px !important;
}

.quadrant-image {
    max-width: 900px;
    max-height: 900px;
    overflow: auto;
    scrollbar-width: thin;
}

.camera-app-input-field {
    width: 72px;
}

.arrow {
    border: solid black;
    border-width: 0 3px 3px 0;
    padding: 3px;
}

.display-inline {
    display: inline-block;
}

.display-block {
    display: block;
}
  
.right {
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
}
  
.left {
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
}
  
.up {
    transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
}
  
.down {
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
}

.line-horizontal {
    height: 1px;
    border-top: 1px solid rgba(0, 0, 0, 0.85);
    margin: 4px 0;
}

.width-normal {
    width: 42.5%;
}

.width-normal-manual-mode {
    width: 40.5%;
}

.width-fullscreen {
    width: 43%;
}

.width-fullscreen-manual-mode {
    width: 43.5%;
}

.line-vertical {
    width: 1px;
    border-left: 1px solid rgba(0, 0, 0, 0.85);
    margin: 0 4px;
}

.line-inner-text-horizontal {
    padding: 0 28px;
    font-weight: 500;
}

.line-inner-text-vertical {
    padding: 5px 0;
    font-weight: 500;
    writing-mode: vertical-rl;
    text-orientation: mixed;
    margin-left: -5px;
}`, "",{"version":3,"sources":["webpack://./src/asset/style/manualmode/camera_app.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;IACI,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,yCAAyC;IACzC,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,0CAA0C;IAC1C,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,uBAAuB;IACvB,iBAAiB;AACrB","sourcesContent":[".camera-app-live-mode-width {\n    width: 1307px;\n}\n\n.camera-app-width {\n    width: 1090px;\n}\n\n.camera-app-width-fullscreen {\n    width: 1510px;\n}\n\n.camera-app-width-quadrant {\n    width: 965px;\n}\n\n.vertical-radio-buttons {\n    display: block;\n    height: 30px;\n    line-height: 30px;\n}\n\n.top-most-radio-button {\n    border-radius: 4px 4px 0 0 !important;\n}\n\n.bottom-most-radio-button {\n    border-radius: 0 0 4px 4px !important;\n}\n\n.quadrant-image {\n    max-width: 900px;\n    max-height: 900px;\n    overflow: auto;\n    scrollbar-width: thin;\n}\n\n.camera-app-input-field {\n    width: 72px;\n}\n\n.arrow {\n    border: solid black;\n    border-width: 0 3px 3px 0;\n    padding: 3px;\n}\n\n.display-inline {\n    display: inline-block;\n}\n\n.display-block {\n    display: block;\n}\n  \n.right {\n    transform: rotate(-45deg);\n    -webkit-transform: rotate(-45deg);\n}\n  \n.left {\n    transform: rotate(135deg);\n    -webkit-transform: rotate(135deg);\n}\n  \n.up {\n    transform: rotate(-135deg);\n    -webkit-transform: rotate(-135deg);\n}\n  \n.down {\n    transform: rotate(45deg);\n    -webkit-transform: rotate(45deg);\n}\n\n.line-horizontal {\n    height: 1px;\n    border-top: 1px solid rgba(0, 0, 0, 0.85);\n    margin: 4px 0;\n}\n\n.width-normal {\n    width: 42.5%;\n}\n\n.width-normal-manual-mode {\n    width: 40.5%;\n}\n\n.width-fullscreen {\n    width: 43%;\n}\n\n.width-fullscreen-manual-mode {\n    width: 43.5%;\n}\n\n.line-vertical {\n    width: 1px;\n    border-left: 1px solid rgba(0, 0, 0, 0.85);\n    margin: 0 4px;\n}\n\n.line-inner-text-horizontal {\n    padding: 0 28px;\n    font-weight: 500;\n}\n\n.line-inner-text-vertical {\n    padding: 5px 0;\n    font-weight: 500;\n    writing-mode: vertical-rl;\n    text-orientation: mixed;\n    margin-left: -5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
